import React, { Component } from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DETALLE_POR_CEREAL_LINEA_12 } from '../../../../../config/tables'

export class TablaDetallePorCerealLinea12View extends Component {
  render () {
    return (
      <MuiTable id={TABLA_DETALLE_POR_CEREAL_LINEA_12} />
    )
  }
}
